<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';
  import { cn } from '@/lib/utils';

  interface SkeletonProps {
    class?: HTMLAttributes['class'];
  }

  const props = defineProps<SkeletonProps>();
</script>

<template>
  <div
    :class="
      cn('animate-pulse rounded-xl bg-zinc-200 dark:bg-zinc-800', props.class)
    " />
</template>
